<div
  class="flex flex-column gap-3"
  [ngClass]="{
    'pointer-events-none': hideContent,
    'pointer-events-auto': !hideContent,
  }">
  <div
    class="flex flex-column gap-3 animation-ease-in-out animation-duration-400 w-3rem fixed bottom-0 right-0 m-3 mb-8"
    [ngClass]="{
      fadeinright: showAdder,
      fadeoutright: !showAdder,
      'opacity-0': hideContent,
    }">
    @for (widgetConfig of items; track $index) {
      <div
        [pTooltip]="widgetConfig.tooltip"
        showDelay="100"
        class="text-1xl border-round-3xl shadow-3 bg-green-300"
        (click)="onAddWidget(widgetConfig.type)">
        <div
          [attr.data-type]="widgetConfig['type']"
          class="grid-stack-item widget-adder--draggable cursor-move">
          <div
            class="grid-stack-item--placeholder w-3rem h-3rem flex align-items-center justify-content-center">
            <i [class]="widgetConfig.icon"></i>
          </div>
        </div>
      </div>
    }
  </div>

  <button
    pButton
    [pTooltip]="hideContent ? 'Neue Darstellung hinzufügen' : 'schließen'"
    tooltipPosition="top"
    class="transition-all pointer-events-auto"
    [ngClass]="{ 'rotate-45': !hideContent }"
    icon="fas fa-plus"
    [rounded]="true"
    (click)="toggleAdder()"></button>
</div>
